import CircularBoldWoff from './fonts/lineto-circular-bold.woff';
import CircularBoldWoff2 from './fonts/lineto-circular-bold.woff2';

import RobotoBoldWoff from './fonts/roboto-v20-latin-700.woff';
import RobotoBoldWoff2 from './fonts/roboto-v20-latin-700.woff2';

import RobotoRegularWoff from './fonts/roboto-v20-latin-regular.woff';
import RobotoRegularWoff2 from './fonts/roboto-v20-latin-regular.woff2';

export const circularBold = {
    fontFamily: 'LL Circular Bold Sub',
    fontStyle: 'normal',
    fontWeight: 700,
    src: `
        url(${CircularBoldWoff2}) format('woff2'),
        url(${CircularBoldWoff}) format('woff')
    `,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export const robotoBold = {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    src: `
        url(${RobotoBoldWoff2}) format('woff2'),
        url(${RobotoBoldWoff}) format('woff')
    `,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export const robotoRegular = {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    src: `
        url(${RobotoRegularWoff2}) format('woff2'),
        url(${RobotoRegularWoff}) format('woff')
    `,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};
